import {
	createResource,
	useResource,
	type RouteResource,
	type UseResourceHookResponse,
} from '@atlassian/react-resource-router';
import { fetchWorkflowBuilderProvisioning } from './fetchWorkflowBuilderProvisioning.tsx';

export const RESOURCE_TYPE_KEY = 'ADMIN_WORKFLOW_BUILDER_PROVISIONING';

export const workflowBuilderProvisioningResource: RouteResource<boolean> = createResource<boolean>({
	type: RESOURCE_TYPE_KEY,
	getKey: () => RESOURCE_TYPE_KEY,
	getData: fetchWorkflowBuilderProvisioning,
	maxAge: 1000,
	isBrowserOnly: true,
});

export const useWorkflowBuilderProvisioning = (): UseResourceHookResponse<boolean> =>
	useResource<boolean>(workflowBuilderProvisioningResource);
